import { IPaymentConfig, IPaymentConfigRaw } from 'models/config.model'

export const getPaymentConfigFromConfigRaw = (
  paymentConfig: IPaymentConfigRaw,
): IPaymentConfig => ({
  stripe: {
    accountId: paymentConfig.stripe.account_id,
    accountName: paymentConfig.stripe.account_name,
    publicKey: paymentConfig.stripe.public_key,
    paymentMethods: paymentConfig.stripe.payment_methods || [],
  },
  paypal: {
    clientId: paymentConfig.paypal.client_id,
  },
  primer: {
    enabled: paymentConfig.primer.enabled,
    paypalEnabled: paymentConfig.primer.paypal_enabled,
  },
})
